// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DTcc","option":"styles_option__QMaWa","active":"styles_active__1-Ley"};